<template>
  <div>
    <div class="userinfo">
      <div class="contents">
        <div class="userleft">
          <user-nav @switchmenu="switchmenu" ref="userNav" />
        </div>
        <div class="userright">
          <user-info v-if="nowindex == 0" @nowindex="cNowindex" />
          <user-collection v-if="nowindex == 1" />
          <user-relation v-if="nowindex == 5"></user-relation>
          <user-reset-password v-if="nowindex == 3" />
          <delete-user v-if="nowindex == 4" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HtmlFooter from "../../components/common/HtmlFooter.vue";
import HtmlTop from "../../components/common/HtmlTop.vue";
import NavMenu from "../../components/common/NavMenu.vue";
import UserCollection from "../../components/user/UserCollection.vue";
import UserInfo from "../../components/user/UserInfo.vue";
import UserNav from "../../components/user/UserNav.vue";
import UserResetPassword from "../../components/user/UserResetPassword.vue";
import DeleteUser from "../../components/user/DeleteUser.vue";
import { MessageBox } from "element-ui";
import { mapActions } from "vuex";
import UserRelation from "../../components/user/UserRelation.vue";
export default {
  data() {
    return {
      nowindex: 0
    };
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案"
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案"
        }
      ]
    };
  },
  components: {
    HtmlTop,
    NavMenu,
    HtmlFooter,
    UserNav,
    UserInfo,
    UserCollection,
    UserResetPassword,
    DeleteUser,
    UserRelation
  },
  methods: {
    ...mapActions(["LoginOut"]),
    cNowindex(val) {
      this.nowindex = val;
      this.$refs.userNav.onpic(val);
    },
    switchmenu(val) {
      if (val == "2") {
        MessageBox.confirm("确认退出？")
          .then(_ => {
            //退出登录
            this.LoginOut();
            this.$router.push({ name: "login" });
            done();
          })
          .catch(_ => {
            //console.log("b")
          });
      } else {
        this.nowindex = val;
      }
    }
  }
};
</script>

<style scoped>
.userinfo {
  background-color: #f3f5f7;
  overflow: hidden;
}
.contents {
  margin-top: 38px;
  overflow: hidden;
}
.userleft {
  width: 206px;
  float: left;
  margin-right: 23px;
}
.userright {
  width: 971px;
  min-height: 700px;
  background-color: #fff;
  float: left;
  margin-bottom: 30px;
  padding-bottom: 58px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/index.vue